window.CognitoUserManagerAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.getBaseAPI('CognitoUserManager'));

    self.exchangeCustomToken = function (customToken) {
        var deferred = $q.defer();
        var payLoad = {
            custom_token: customToken
        }
        _protected.request('public/users/custom_token/exchange', 'POST', payLoad)
            .then(function (result) {
                deferred.resolve(result.data);
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
};